import { Spin } from '@piccolohealth/ui';
import React from 'react';
import type { ReactJsonViewProps } from 'react-json-view';

const ReactJson = React.lazy(() => import('react-json-view'));

export const JsonTree = (props: ReactJsonViewProps) => {
  return (
    <React.Suspense fallback={<Spin />}>
      <ReactJson {...props} />
    </React.Suspense>
  );
};
